export default {
  title: "Abbonamento",
  description: "Gestisci il tuo piano e la fatturazione",
  plans: {
    free: "Gratuito",
    essential: "Essenziale",
    pro: "Pro",
    premium: "Premium"
  },
  currentPlanMessage: {
    free: "Stai utilizzando il piano Gratuito",
    pro: "Sei un membro Premium!"
  },
  eventsUsed: "Eventi utilizzati",
  featureRestricted: "Questa funzionalità richiede un abbonamento",
  pageTitle: "Scegli il tuo piano",
  pageDescription: "Seleziona il piano più adatto alle tue esigenze",
  plan: {
    free: "Gratuito",
    basic: "Base",
    premium: "Premium",
    pro: "Pro",
    essential: "Essenziale"
  },
  currentPlan: "Piano attuale",
  mostPopular: "Più popolare",
  choosePlan: "Scegli questo piano",
  freePrice: "0€",
  essentialPrice: "15€/mese",
  proPrice: "30€/mese",
  freeDescription: "Perfetto per iniziare",
  essentialDescription: "Per matrimoni classici",
  proDescription: "Per grandi eventi",
  unlimited: "Illimitato",
  subscriptionUpdated: "Il tuo abbonamento è stato aggiornato con successo",
  updateError: "Errore durante l'aggiornamento dell'abbonamento",
  usingBasicFeatures: "Uso delle funzionalità di base",
  limitReached: "Limite {{limit}} raggiunto ({{count}}/{{max}})",
  upgradeToIncreaseLimits: "Fai l'upgrade per aumentare questi limiti",
  multipleEventsRestricted: "La gestione di più eventi è limitata",
  upgradeToProForMultipleEvents: "Passa a Pro per gestire più eventi",
  viewPlans: "Vedi piani",
  upgradeToAccessPlan: "Passa al piano {{plan}} per accedere a questa funzione",
  upgradeToAccessFeature: "Passa a un piano superiore per accedere a {{feature}}",
  features: {
    title: "Caratteristiche",
    weddingWebsite: "Sito web del matrimonio",
    exportPDF: "Esportazione PDF",
    exportExcel: "Esportazione Excel",
    customDomain: "Dominio personalizzato",
    adsRemoval: "Rimozione annunci",
    guestGroups: "Gruppi di ospiti",
    seatingPlanner: "Disposizione dei tavoli",
    budgetAnalytics: "Analisi del budget",
    aiAssistant: "Assistente IA",
    customFields: "Campi personalizzati",
    prioritySupport: "Supporto prioritario"
  },
  limits: {
    title: "Limiti",
    maxGuests: "Numero massimo di ospiti",
    maxTasks: "Attività massime",
    maxVendors: "Fornitori massimi",
    maxCollaborators: "Collaboratori massimi"
  },
  faq: {
    title: "Domande frequenti",
    question1: "Posso cambiare piano in qualsiasi momento?",
    answer1: "Sì, puoi aggiornare o declassare il tuo piano in qualsiasi momento. Le modifiche hanno effetto immediato.",
    question2: "Ci sono costi nascosti?",
    answer2: "No, tutti i nostri prezzi sono trasparenti. Non verranno addebitati costi aggiuntivi.",
    question3: "Posso cancellare in qualsiasi momento?",
    answer3: "Sì, puoi annullare l'abbonamento in qualsiasi momento. Manterrai l'accesso fino alla fine del periodo di fatturazione.",
    question4: "Offrite sconti per studenti?",
    answer4: "Sì, offriamo uno sconto del 20% per gli studenti. Contattaci per maggiori informazioni.",
    multipleEventsQuestion: "Posso gestire più eventi?",
    multipleEventsAnswer: "Con il piano Pro, puoi gestire un numero illimitato di eventi. I piani gratuiti ed essenziali sono limitati a un evento."
  },
  billing: {
    monthly: "Mensile",
    yearly: "Annuale",
    save: "Risparmia {{percent}}%"
  },
  actions: {
    upgrade: "Migliora",
    downgrade: "Declassa",
    cancel: "Annulla abbonamento",
    reactivate: "Riattiva abbonamento"
  },
  messages: {
    upgradeSuccess: "Il tuo piano è stato aggiornato con successo",
    downgradeSuccess: "Il tuo piano è stato declassato con successo",
    cancelSuccess: "Il tuo abbonamento è stato annullato",
    reactivateSuccess: "Il tuo abbonamento è stato riattivato"
  }
,

  pageSubtitleNew: "Adatta WedBox alle tue esigenze con i nostri piani flessibili",
  refreshBtn: "Aggiorna",
  popular: "Popolare",
  current: "Attuale",
  freePlanBtn: "Piano gratuito",
  upgradeTo: "Passa a {{plan}}",
  currentPlanBtn: "Piano attuale",
  usage: {
    events: "Gestione eventi",
    guests: "Ospiti",
    tasks: "Attività",
    vendors: "Fornitori"
  },
  units: {
    events: "evento(i)",
    guests: "ospite(i)",
    tasks: "attività",
    vendors: "fornitore(i)"
  },
  checkout: {
    title: "Pagamento sicuro",
    secureStripe: "Pagamento sicuro con Stripe",
    cancelAnytime: "Puoi annullare l'abbonamento in qualsiasi momento dal tuo account.",
    lastRefresh: "Ultimo aggiornamento:",
    mustBeLoggedIn: "Devi accedere per procedere al pagamento",
    freeNoPayment: "Il piano gratuito non richiede pagamento",
    creatingSession: "Creazione della sessione di pagamento...",
    redirecting: "Reindirizzamento a Stripe...",
    subscribeTo: "Abbonati al piano {{plan}}",
    cancel: "Annulla",
    securePayment: "Pagamento sicuro tramite Stripe"
  },
  planDetails: {
    free: {
      name: "Gratuito",
      price: "0€",
      description: "Perfetto per iniziare",
      features: [
        "Gestisci 1 evento",
        "Fino a 50 ospiti",
        "Max 20 attività",
        "10 fornitori",
        "Supporto della community"
      ]
    },
    essential: {
      name: "Essenziale",
      price: "9€",
      description: "Per eventi importanti",
      features: [
        "Gestisci 3 eventi",
        "Fino a 200 ospiti",
        "Attività illimitate",
        "25 fornitori",
        "Esportazione PDF/Excel",
        "Gruppi di ospiti",
        "Supporto prioritario"
      ]
    },
    pro: {
      name: "Pro",
      price: "19€",
      description: "Soluzione completa",
      features: [
        "Eventi illimitati",
        "Ospiti illimitati",
        "Attività illimitate",
        "Fornitori illimitati",
        "Pianificatore tavoli",
        "Analisi avanzate",
        "Report personalizzati",
        "Supporto premium"
      ]
    }
  }

};
